<template>
    <div class="setting">
        <div class="setting__label">{{$t(item.texts.Title)}}</div>
        <div class="setting__option setting__select">
            <select class="form-control" v-model="item.selected">
                <option disabled="disabled" value="">{{$t(item.texts.ddTitle)}}</option>
                <option v-for="(options,index) in item.items" :key="options.id" :value="index">{{options.name}}</option>
            </select>
    
        </div>
    </div>
</template>

<script>

export default {
    name: 'input-dropdown',
    props: ['item', 'index'],
    data() {
        return {
            title: null
        }
    },
    methods: {
        selectItem() {
            //this.tech.selected = !this.tech.selected;
            //this.$emit('unit-clicked', this);
        }
    },
    mounted: function () {
        this.$nextTick(function () {
            //this.iTitle = (this.displayUnit) ? this.tech.type : this.tech.title;
        });
    }
}
</script>

<style lang="css" >

</style>


// WEBPACK FOOTER //
// input.dropdown.vue?04626c36